import { render, staticRenderFns } from "./NotificationsContactSalesButton.vue?vue&type=template&id=bae63af4&scoped=true&"
import script from "./NotificationsContactSalesButton.vue?vue&type=script&lang=js&"
export * from "./NotificationsContactSalesButton.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsContactSalesButton.vue?vue&type=style&index=0&id=bae63af4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae63af4",
  null
  
)

export default component.exports